import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Tooltip,
  SelectChangeEvent,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useSearchContext } from "../../../contexts/SearchContext";
import { useMixIdeal } from "../../../hooks/queries/useMixIdeal";
import { FilterSelect } from "./FilterSelect";

const FilterMixIdeal = () => {
  const { searchMixIdeal, setSearchMixIdeal } = useSearchContext();
  const { data: mixIdeal = [] } = useMixIdeal();

  const onChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value !== "0" ? event.target.value : "*";
    setSearchMixIdeal(value);
  };

  return (
    <Box display="flex" alignItems="center">
      <FormControl size="small" variant="outlined" fullWidth>
        <InputLabel sx={{ fontWeight: "bold", color: "rgba(0, 0, 0, 0.87)" }}>
          Mix Ideal:
        </InputLabel>
        <FilterSelect
          value={searchMixIdeal}
          onChange={onChange}
          label="Mix Ideal"
        >
          <MenuItem value="*">Selecione</MenuItem>
          {mixIdeal.map(item => (
            <MenuItem key={item.cd_fornecedor} value={item.cd_fornecedor}>
              {item.ds_fornecedor}
            </MenuItem>
          ))}
        </FilterSelect>
      </FormControl>
      <Tooltip
        title="Este filtro é livre e não depende dos filtros acima."
        placement="right"
      >
        <InfoIcon color="primary" />
      </Tooltip>
    </Box>
  );
};

export default FilterMixIdeal;
